module.exports = __webpack_public_path__ + "img/Recurso 2@300x.62ff600b.webp";